import { render, staticRenderFns } from "./SocItem.vue?vue&type=template&id=a2e65d6e&scoped=true"
import script from "./SocItem.vue?vue&type=script&lang=js"
export * from "./SocItem.vue?vue&type=script&lang=js"
import style0 from "./SocItem.vue?vue&type=style&index=0&id=a2e65d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e65d6e",
  null
  
)

export default component.exports